import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackSEOCopyToggle = ({ heading, open }: { heading: string; open: boolean }) => {
  // Defer off the interaction's critical path: fire-and-forget, does not gate the accordion toggle.
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Category page',
      event_action: `SEO copy - ${open ? 'see more' : 'see less'}`,
      event_label: `category - ${heading}`,
    }),
  );
};
